import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp, watch } from 'vue'

import App from './App.vue'
import { i18n, resolveLocale, setI18nLocale } from './i18n'
import router from './router'
import { initAnalytics, track } from './services/analytics'
import { useAuthStore } from './stores/auth'
import './styles/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        // Finansal veri sık değişmez ama eskimemesi de önemli: pencereye
        // geri dönüldüğünde tazelensin, her odaklanmada değil.
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        // 401 ve 403 tekrar denemeyle düzelmez; sadece ağ/sunucu hatalarında dene.
        retry: (failureCount, error) => {
          const status = (error as { status?: number })?.status
          if (status && status < 500) return false
          return failureCount < 2
        },
      },
    },
  },
})

// Dil, kullanıcının profil tercihini takip eder. Sunucudan gelen `locale`
// değiştiğinde arayüz de değişsin.
const auth = useAuthStore(createPinia())
setI18nLocale(resolveLocale(auth.locale))
watch(
  () => auth.locale,
  (next) => setI18nLocale(resolveLocale(next)),
)

// Analitik uygulamadan SONRA başlatılıyor ve beklenmiyor: ölçüm,
// panelin açılmasını geciktirmemeli.
void initAnalytics().then(() => {
  // Ekran görüntüleme olayı ROTA DEĞİŞİMİNDE gönderiliyor. Tek sayfa
  // uygulamasında tarayıcı gezinme olayı üretmiyor; otomatik toplama
  // yalnızca ilk yüklemeyi görürdü.
  //
  // Yol ADI gönderiliyor, tam URL değil: bazı yollarda kimlik geçiyor
  // (/debts/:id) ve o kimlikler analitik sağlayıcısına gitmemeli.
  router.afterEach((to) => {
    track('screen_view', { screen_name: String(to.name ?? 'unknown') })
  })
})

app.mount('#app')
